export { GetSchoolCollectionQuery } from './get-school-collection';
export { GetSchoolCollectionLazyQuery } from './get-school-collection-lazy';
export { GetSchoolQuery } from './get-school';
export { GetSchoolSummaryStatsQuery } from './get-school-summary-stats';
